export const getImageDimensions = async (data: string) => {
  const img = new Image();

  img.src = data;

  // we wait until img process given base64 string
  await img.decode();

  //   once it done we extract dimensions from the img object
  const { width, height } = img;

  return { width, height };
};
